import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M6 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM8 4h14v2H8V4ZM8 11v2h14v-2H8ZM22 18H8v2h14v-2ZM6 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM4 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }